import { ReadingType, spirometryLookupTable } from "./spirometryLookupTable";

export const getSpirometryLookupTableValue = (gender: string, age: number, height: number, ethnicity: string, reading: ReadingType) => {
    const valuesTable = spirometryLookupTable.find(t => t.ethnicity === ethnicity && t.gender === gender);
    const ageTable = valuesTable && valuesTable[reading]?.find(t => t.age >= age);
    const tableValue = ageTable?.values.find(v => v.height >= height);
    return tableValue?.value;
};
